import { AxiosResponse } from 'axios';
import { FormikHelpers } from 'formik';

import { useFormContext } from 'context/FormContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { ConfigBi } from 'pages/bi/types';

export function useMutateBiForm() {
    const { setContent } = useFormContext();
    const { mutate, isLoading } = useFormMutation<AxiosResponse<{ data: ConfigBi }>>();

    /**
     * Envia os dados do formulário para a API.
     */
    const handleSubmit = (formData: ConfigBi, formik: FormikHelpers<ConfigBi>) => {
        mutate(
            {
                formik,
                formData,
                url: '/config/configbiwrapper',
                idField: 'idConfigBi',
            },
            {
                onSuccess: (data) => setContent(data.data.data),
            },
        );
    };

    return { handleSubmit, isLoading };
}
